// @spec GHG-STR-001
'use client';

import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/ghg-boundary')({
  component: () => <Navigate to="/ghg/setup" replace />,
});
